import React from 'react';
import { ChevronRightIcon as RightArrow } from '@domain-group/fe-co-icon';
import { Badge } from '@domain-group/fe-co-allhomes-design-system';
import * as styles from './default-card.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var LEFT_IMAGE_LINES = 3;
var DEFAULT_LINES = 2;
var DefaultCard = _ref => {
  var article = _ref.article,
    _ref$useIndexHeadline = _ref.useIndexHeadline,
    useIndexHeadline = _ref$useIndexHeadline === void 0 ? false : _ref$useIndexHeadline,
    _ref$imagePosition = _ref.imagePosition,
    imagePosition = _ref$imagePosition === void 0 ? 'left' : _ref$imagePosition,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === void 0 ? () => {} : _ref$onClick,
    _ref$maxLines = _ref.maxLines,
    maxLines = _ref$maxLines === void 0 ? DEFAULT_LINES : _ref$maxLines,
    _ref$fixedHeight = _ref.fixedHeight,
    fixedHeight = _ref$fixedHeight === void 0 ? false : _ref$fixedHeight,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? '' : _ref$target,
    _ref$rel = _ref.rel,
    rel = _ref$rel === void 0 ? '' : _ref$rel;
  var _article$image = article.image,
    image = _article$image === void 0 ? '' : _article$image,
    _article$url = article.url,
    url = _article$url === void 0 ? '' : _article$url,
    _article$excerpt = article.excerpt,
    excerpt = _article$excerpt === void 0 ? '' : _article$excerpt,
    _article$title = article.title,
    title = _article$title === void 0 ? null : _article$title,
    _article$indexHeadlin = article.indexHeadline,
    indexHeadline = _article$indexHeadlin === void 0 ? null : _article$indexHeadlin,
    _article$tags = article.tags,
    tags = _article$tags === void 0 ? [] : _article$tags;
  var articleTitle = useIndexHeadline ? indexHeadline : title;
  var leftImage = imagePosition === 'left';
  return ___EmotionJSX("div", {
    css: styles.articleCard,
    className: className
  }, ___EmotionJSX("a", {
    href: url,
    css: styles.link,
    target: target,
    rel: rel,
    onClick: onClick
  }, image && !leftImage && ___EmotionJSX("div", {
    css: styles.topImageContainer
  }, ___EmotionJSX("img", {
    src: image,
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.content
  }, image && leftImage && ___EmotionJSX("div", {
    css: styles.leftImageContainer
  }, ___EmotionJSX("img", {
    src: image,
    alt: ""
  })), ___EmotionJSX("div", {
    css: styles.middle
  }, articleTitle && ___EmotionJSX("div", {
    css: styles.heading
  }, articleTitle), ___EmotionJSX("div", {
    css: styles.description({
      fixedHeight,
      maxLines: maxLines || (leftImage && image ? LEFT_IMAGE_LINES : DEFAULT_LINES)
    })
  }, excerpt), ___EmotionJSX("div", {
    css: styles.tags
  }, tags.filter(Boolean).map(item => ___EmotionJSX(Badge, {
    key: item.slug,
    label: item.label,
    css: styles.tag
  })), fixedHeight && tags.filter(Boolean).length === 0 ? ___EmotionJSX("div", {
    css: styles.tags
  }, "\xA0") : null)), ___EmotionJSX("div", {
    css: styles.arrow
  }, ___EmotionJSX(RightArrow, {
    size: "regular"
  })))));
};
export default DefaultCard;